import gql from 'graphql-tag';
import { OFFER_PROMO_FRAGMENT } from './fragments/OfferFragment';

export const GET_OFFER_BY_ID_WITH_STATS_QUERY = gql`
  query GetofferByIdWithStats($id: Int!, $startDate: DateTime, $endDate: DateTime) {
    offer: offerByIdWithStats(id: $id, startDate: $startDate, endDate: $endDate) {
      offer {
        type
        createdDate
        description
        expirationDate
        archivedDate
        archivedUser {
          name
          email
        }
        expired
        id
        name
        imageUrl
        icon
        programId
        showSendConfirmationScreen
        isNewFlow
        offerAutomationConfig {
          id
          isActive
          automationType
          automationStartDate
          tierAggregationDuration
          showInCreatorPortal
        }
        isReadOnly
        isPromoLink
        isLandingPageEnabled
        landingPageUrl
        showPayoutsOnCreatorPortal
        hideOfferFromCreators
        isDiscountBoostOffer
        boosts {
          activeEndDate
          activeStartDate
          boostMetadata
          boostType
          createdDate
          discountOfferId #can be used to redirect to the boost offer
          hideInCreatorPortal
          id
          isActive
          label
          maxLimit
          requireApproval
          triggerType
          triggerValue
          updatedDate
          discountOffer {
            promos {
              ...OfferPromoFragment
            }
          }
          boostEligibility {
            id
            createdDate
            eligibilityType
            memberIds
            updatedDate
            advancedSelectionMetadata
            advancedSelectionOperator
          }
        }
        payouts {
          id
          payoutType
          label
          flatPayout
          percentPayout
          offerId
          isMemberAdded
          createdDate
          automationThreshold
          offerAutomationConfigId
          offerPayoutRules {
            id
            operator
            collections {
              id
              name
              advertiserId
              operator
            }
            duration {
              startDate
              endDate
            }
            flatPayout
            orderSubtotal {
              value
              operator
            }
            percentPayout
            products {
              id
              name
              type
              imageUrl
              advertiserId
              operator
            }
            recurringLimit {
              isLimitPayoutToFirstOrder
              isPayoutAppliedToAllRecurringOrders
              limitPayoutToMultipleRecurringOrder
            }
          }
        }
        promos {
          affiliates {
            id
          }
          codeSuffix
          codePrefix
          disabled
          flatPayout
          id
          name
          offerId
          payoutType
          percentPayout
          prefixType
          priceRuleAmount
          priceRuleType
          source
          specialLimitNewCustomersOnly
          specialLimitOnePerSale
          specialLimitUsageCapAmount
          specialLimitUsageCapEnabled
          status
          defaultPayoutId
          usageLimitAmount
          usageLimitRule
          providerMetadata {
            productCollections {
              id
              title
            }
            discountCombination {
              orderDiscounts
              productDiscounts
              shippingDiscounts
            }
          }
          isSubscription
          isUngrouped
          isOneTime
          recurringCycleLimit
          discountCodeGId
          startDate
          endDate
          multiShopifyEnabled
          isSecureCodes
          connectedClientMetadata {
            advertiserId
            priceRuleType
            priceRuleAmount
            status
            discountCodeGid
          }
        }
        links {
          affiliates {
            id
          }
          defaultPayoutId
          affiliateOfferLinkGenerated
          conversionTrackingType
          conversionType
          flatPayout
          id
          payoutType
          percentPayout
          pixelCode
          postbackUrl
          status
          url
          utmFields
          domains
          creatorDeeplink
          allowMultipleConversions
          thirdPartyTracking
          trackPayoutInAspire
          isThirdPartyIntegration
          isCreatorDeepLinkEnabled: creatorDeeplink
          shopifyRedirectUrl
        }
      }
      promoStats {
        avgSale
        conversions
        payoutEarned
        payoutMade
        sales
        salesBase
        avgSaleBase
        payoutEarnedBase
        baseCurrencies
      }
      linkStats {
        avgSale
        conversions
        payoutEarned
        payoutMade
        sales
        clicks
        conversions
        salesBase
        avgSaleBase
        payoutEarnedBase
        baseCurrencies
        nonDuplicateConversions
      }
    }
  }
  ${OFFER_PROMO_FRAGMENT}
`;
